import { gql } from '@apollo/client';

export const GET_WALKTHROUGH_HOURS_THRESHOLD = gql`
  query GetWalkthroughHoursThreshold {
    walkthroughHoursThreshold
  }
`;

export const SET_WALKTHROUGH_HOURS_THRESHOLD = gql`
  mutation SetWalkthroughHoursThreshold($hours: Int!) {
    setWalkthroughHoursThreshold(hours: $hours)
  }
`;

export const GET_TIME_CLOCK_MAX_HOURS_PER_DAY = gql`
  query GetTimeClockMaxHoursPerDay {
    timeClockMaxHoursPerDay
  }
`;

export const GET_IS_TIME_CLOCK_GLOBALLY_ENABLED = gql`
  query GetIsTimeClockGloballyEnabled {
    isTimeClockGloballyEnabled
  }
`;

export const SET_TIME_CLOCK_MAX_HOURS_PER_DAY = gql`
  mutation SetTimeClockMaxHoursPerDay($hours: Int!) {
    setTimeClockMaxHoursPerDay(hours: $hours)
  }
`;

export const SET_TIME_CLOCK_GLOBALLY_ENABLED = gql`
  mutation SetTimeClockGloballyEnabled($enabled: Boolean!) {
    setTimeClockGloballyEnabled(enabled: $enabled)
  }
`;

export const GET_TIME_CLOCK_OFFICE_RADIUS_METERS = gql`
  query GetTimeClockOfficeRadiusMeters {
    timeClockOfficeRadiusMeters
  }
`;

export const SET_TIME_CLOCK_OFFICE_RADIUS_METERS = gql`
  mutation SetTimeClockOfficeRadiusMeters($meters: Int!) {
    setTimeClockOfficeRadiusMeters(meters: $meters)
  }
`;

export const GET_SYSTEM_SETTINGS = gql`
  query GetSystemSettings {
    systemSettings {
      id
      key
      value
      description
      dataType
    }
  }
`;

export const UPDATE_SYSTEM_SETTING = gql`
  mutation UpdateSystemSetting($key: String!, $value: String!, $description: String, $dataType: String) {
    updateSystemSetting(key: $key, value: $value, description: $description, dataType: $dataType) {
      id
      key
      value
      description
      dataType
    }
  }
`;
